import { render, staticRenderFns } from "./VersionCopy.vue?vue&type=template&id=7645e218&scoped=true"
import script from "./VersionCopy.vue?vue&type=script&lang=js"
export * from "./VersionCopy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7645e218",
  null
  
)

export default component.exports